import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit {

  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  offers: any = [];
  allOffers: any = [];
  sendData: any = {};
  isListEnd: boolean = false
  offset: number = 0
  offsetLoader: boolean = false
  offsetResFetched: boolean = true
  showLoaderProduct: boolean = false

  ngOnInit() {
    setTimeout(() => {
      this.loadData(1)
    },1);
  }

  loadData(flag) {
    flag == 1 ? this.showLoaderProduct = true : this.offsetLoader = true
    this.sendData = {
      Limit: 10,
      Offset: this.offset
     }

    this.service.create(this.baseUrl + 'OfferAPI/GetAllOffers', this.sendData)
      .subscribe(
        data => {
          console.log(data)
          this.offsetResFetched = true
          this.offsetLoader = false
          this.offset = this.offset + 10
          this.offers = data;
          for (var i = 0; i < this.offers.length; i++){
            this.allOffers.push(this.offers[i]);
          }
          if (this.offers.length == 0) {
             this.isListEnd = true
          }
          this.showLoaderProduct = false
        },
        (error) => {
          this.showLoaderProduct = false
        })
  }


    @HostListener('window:scroll', [])
    onScroll(): void {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && this.allOffers.length > 0) {
        if ( !this.isListEnd && this.offsetResFetched) {
          console.log('a')
          this.offsetResFetched = false
          this.loadData(2)
        }
      }
    }

}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/offers/offers.component.ts